import PropTypes from "prop-types"
import { percentageFormatter } from "helpers/formatters/numbers"
import OPTooltip from "components/material/tooltip"
import "./style.scss"

export default function SmartTradeHeadline(props) {
  const { risk, refInstrument, change, type } = props
  if (!risk || !risk.refInstrument || !risk.smartTrade) { return null }
  return (<>
    <span>Smart <span>{type}</span>&nbsp;</span>
    <span>{change}</span>
    &nbsp;
    <OPTooltip title={refInstrument.title} placement="bottom">
      <b className="instrument-name">{refInstrument.display}</b>
    </OPTooltip>
    &nbsp;specific risk from&nbsp;
    <b>{percentageFormatter(risk.refInstrument)}</b>
    &nbsp;to&nbsp;
    <b>{percentageFormatter(risk.smartTrade)}</b>
  </>)
}

SmartTradeHeadline.propTypes = {
  change: PropTypes.string,
  type: PropTypes.string,
  refInstrument: PropTypes.shape({
    title: PropTypes.string,
    display: PropTypes.string,
  }),
  risk: PropTypes.shape({
    refInstrument: PropTypes.number,
    smartTrade: PropTypes.number,
  }),
}
